/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CollaborationStateEnum {
    Pending = 'PENDING',
    Ongoing = 'ONGOING',
    Expired = 'EXPIRED',
    Confirmed = 'CONFIRMED',
    Canceled = 'CANCELED'
}

export function CollaborationStateEnumFromJSON(json: any): CollaborationStateEnum {
    return CollaborationStateEnumFromJSONTyped(json, false);
}

export function CollaborationStateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollaborationStateEnum {
    return json as CollaborationStateEnum;
}

export function CollaborationStateEnumToJSON(value?: CollaborationStateEnum | null): any {
    return value as any;
}

